/**
 * Cohort identifiers returned by the per-currency GrowthBook flags.
 * Standard cohorts apply to EUR/GBP/USD-US/USD-ROW/AUD/BRL.
 * INR has its own cohort vocabulary.
 */
export type StandardCohort = 'control' | 'moderate' | 'aggressive';
export type InrCohort = 'control' | 'reduced' | 'lowest';
export type Cohort = StandardCohort | InrCohort;

export const STANDARD_COHORTS: readonly StandardCohort[] = [
  'control',
  'moderate',
  'aggressive',
] as const;

export const INR_COHORTS: readonly InrCohort[] = [
  'control',
  'reduced',
  'lowest',
] as const;

const ALL_COHORTS = new Set<string>([...STANDARD_COHORTS, ...INR_COHORTS]);

/**
 * Coerce an unknown GrowthBook flag value into a known `Cohort`. Returns
 * `'control'` for any unrecognised string (e.g. typo'd cohort name in the
 * GrowthBook config) — safer than letting the unknown value flow through
 * to the override lookup, which would fail closed silently anyway.
 */
export function coerceCohort(value: string | undefined): Cohort {
  if (value && ALL_COHORTS.has(value)) {
    return value as Cohort;
  }
  return 'control';
}
